import { Box, CircularProgress } from '@mui/joy';

export default function RouteLoader() {
    return (
        <Box sx={{ height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
        </Box>
    );
}